const selectBlocksUnderHeading = ({
  pageState: { editorBlocks, editorBlocksOrder },
  data: { blockId }
}) => {
  const blockIds = [`${blockId}`];
  const headingLevel = editorBlocks[blockId].data.headingLevel || 'H2';

  let index = editorBlocksOrder.indexOf(blockId) + 1;
  while (index < editorBlocksOrder.length) {
    const id = editorBlocksOrder[index];

    if (editorBlocks[id].type === 'heading') {
      const blockHeadingLevel = editorBlocks[id].data.headingLevel || 'H2';

      if (headingLevel === blockHeadingLevel) break;
      if (headingLevel === 'H3' && blockHeadingLevel === 'H2') break;
    }

    blockIds.push(`${id}`);
    index++;
  }

  if (!blockIds.length) return null;

  const modifiedBlocks = { ...editorBlocks };
  blockIds.forEach((blockId) => {
    modifiedBlocks[blockId] = { ...editorBlocks[blockId], isSelected: true };
  });

  return { editorBlocks: modifiedBlocks };
};

export default selectBlocksUnderHeading;
